import { Plus } from 'lucide-react';

interface TagsPageActionsProps {
  onCreateTag: () => void;
}

export function TagsPageActions({ onCreateTag }: TagsPageActionsProps) {
  return (
    <button
      type="button"
      className="focus-ring inline-flex h-10 items-center gap-1.5 whitespace-nowrap rounded-lg border border-backoffice-500 bg-backoffice-500 px-3 text-small font-medium text-white hover:bg-backoffice-600"
      onClick={onCreateTag}
    >
      <Plus className="h-4 w-4" aria-hidden="true" />
      Create tag
    </button>
  );
}
